module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contentBlock"
  }, [_c('el-container', [_c('el-header', [_c('div', {
    staticClass: "search"
  }, [_c('header', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("| 筛选条件")]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "输出类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.formInline.transactionType),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "transactionType", $$v)
      },
      expression: "formInline.transactionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "充值",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "支出",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "people",
    attrs: {
      "label": "人员："
    }
  }, [_c('div', [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInline.checkedPerson),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedPerson", $$v)
      },
      expression: "formInline.checkedPerson"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.peopleArr), function(peopleObj, pIndex) {
    return _c('el-option', {
      key: pIndex,
      attrs: {
        "label": peopleObj.vipCode,
        "value": peopleObj.vipCode
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "search-icon",
    attrs: {
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.showUserDialog
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "56px"
    },
    attrs: {
      "label": "时间范围:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.formInline.checkedTime)
      }
    },
    model: {
      value: (_vm.formInline.checkedTime),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedTime", $$v)
      },
      expression: "formInline.checkedTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "批次："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.formInline.checkedBatch),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedBatch", $$v)
      },
      expression: "formInline.checkedBatch"
    }
  }, _vm._l((_vm.batchArr), function(batchObj) {
    return _c('el-option', {
      key: batchObj.sendId,
      attrs: {
        "label": batchObj.remark,
        "value": batchObj.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("筛选数据")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcel()
      }
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)])]), _vm._v(" "), _c('el-main', {
    staticStyle: {
      "margin-top": "100px",
      "box-sizing": "border-box"
    }
  }, [_c('div', {
    staticClass: "bodyContent"
  }, [(_vm.showWhichTable == 1) ? _c('div', {
    staticClass: "navCalss"
  }, [_vm._v("\n          | 流水页-充值/支出\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table_in",
    staticStyle: {
      "max-width": "1700px"
    }
  }, [(_vm.showWhichTable == 1) ? _c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "max-height": "600px"
    }
  }, [(_vm.formInline.transactionType == 1) ? _c('el-table-column', {
    key: 1,
    attrs: {
      "prop": "balanceNo",
      "label": "充值账单流水号",
      "width": "170",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 2) ? _c('el-table-column', {
    key: 2,
    attrs: {
      "prop": "balanceNo",
      "label": "支出账单流水号",
      "width": "170",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 2) ? _c('el-table-column', {
    key: 3,
    attrs: {
      "prop": "vipCode",
      "width": "100",
      "label": "客户vip号",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 1) ? _c('el-table-column', {
    key: 4,
    attrs: {
      "prop": "vipCode",
      "width": "100",
      "label": "充值人vip号",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "align": "center",
      "min-width": "140",
      "label": "摘要"
    }
  }), _vm._v(" "), (_vm.formInline.transactionType == 2) ? _c('el-table-column', {
    key: 5,
    attrs: {
      "prop": "amount",
      "width": "140",
      "align": "center",
      "label": "收取金额（CAD）"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 1) ? _c('el-table-column', {
    key: 6,
    attrs: {
      "prop": "amount",
      "align": "center",
      "width": "140",
      "label": "充值金额 CAD"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 1) ? _c('el-table-column', {
    key: 7,
    attrs: {
      "prop": "accountName",
      "align": "center",
      "width": "200",
      "label": "收款类型"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "align": "center",
      "width": "100",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "width": "130",
      "align": "center",
      "label": "操作人"
    }
  }), _vm._v(" "), (_vm.formInline.transactionType == 2) ? _c('el-table-column', {
    key: 8,
    attrs: {
      "prop": "address",
      "align": "center",
      "label": "取货时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.operatorTime ?
          _vm.changeDate(scope.row.operatorTime) :
          "时间未知") + "\n                ")]
      }
    }], null, false, 2559449318)
  }) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 1) ? _c('el-table-column', {
    key: 9,
    attrs: {
      "align": "center",
      "label": "时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.operatorTime ?
          _vm.changeDate(scope.row.operatorTime) :
          "时间未知") + "\n                ")]
      }
    }], null, false, 2559449318)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "afterBalance",
      "width": "200",
      "align": "center",
      "label": "每笔交易之后账号剩余金额（CAD）"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px",
      "padding-right": "40px"
    }
  }, [(_vm.showWhichTable == 1) ? _c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWhichTable == 2) ? _c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginationsPerson.page_sizes,
      "page-size": _vm.paginationsPerson.page_size,
      "layout": _vm.paginationsPerson.layout,
      "total": _vm.paginationsPerson.total,
      "current-page": _vm.paginationsPerson.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChangePerson,
      "size-change": _vm.handleSizeChangePerson
    }
  }) : _vm._e()], 1)])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isShowUserDialog,
      "append-to-body": true,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowUserDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "roleData dialogTitle",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "title-text"
  }, [_vm._v("人员选择")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("客户/vipCode：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入内容",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.roleInput),
      callback: function($$v) {
        _vm.roleInput = $$v
      },
      expression: "roleInput"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.searchRole
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.setRole
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('el-table', {
    ref: "multipleTableRole",
    staticClass: "table",
    attrs: {
      "data": _vm.roleData,
      "border": "",
      "max-height": 580
    },
    on: {
      "select": _vm.selectRoleOnce,
      "selection-change": _vm.selectOptionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vipCode",
      "label": "vipCode",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "label": "客户",
      "align": "center",
      "min-width": "100"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "background": "",
      "current-page": _vm.rolePaginations.page_index,
      "page-sizes": _vm.rolePaginations.page_sizes,
      "page-size": _vm.rolePaginations.page_size,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.rolePaginations.total
    },
    on: {
      "size-change": _vm.rHandleSizeChange,
      "current-change": _vm.rHandleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.cancelRole()
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.certainRole()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27a51348"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/statistical/runningWater.vue
// module id = 1229
// module chunks = 2